import { MobXProviderContext } from 'mobx-react';
import { IMessageReactions } from 'Models/MessageModel';
import { useContext, useEffect } from 'react';
import { RootStoreProps } from 'Stores/RootStore.types';
import { isReactionsObject } from '../../guards';

/**
 * useReactionUserData - Custom hook for loading and retrieving user data for reactions
 *
 * This hook handles:
 * - Loading person data for all users who have reacted
 * - Providing a function to get user names by ID
 */
export const useReactionUserData = (reactions: IMessageReactions) => {
  const { person: personStore } = useContext<RootStoreProps>(MobXProviderContext);

  useEffect(() => {
    if (!reactions) {
      console.warn('[useReactionUserData] Reactions is null or undefined');
      return;
    }

    if (!isReactionsObject(reactions)) {
      console.error('[useReactionUserData] ❌ Invalid reactions format. Expected object with emoji keys and user ID arrays:', reactions);
      return;
    }

    const allPersonIds = new Set<string>();
    Object.values(reactions).forEach((userIds) => {
      userIds.forEach((userId) => allPersonIds.add(userId));
    });

    allPersonIds.forEach((personId) => {
      const personIdNum = parseInt(personId);
      if (!isNaN(personIdNum)) {
        void personStore.loadPersonByIdGetIfMissingGet(personId);
      }
    });
  }, [reactions, personStore]);

  const getUserName = (personId: string): string => {
    const personIdNum = parseInt(personId);
    if (!isNaN(personIdNum)) {
      const currentPerson = personStore.selectPersonValueById(personIdNum);
      if (currentPerson) {
        return currentPerson.name || `${currentPerson.firstName} ${currentPerson.lastName}`.trim();
      }
    }
    return 'Unknown User';
  };

  return { getUserName };
};
